
import { User } from '../types';

export const API_BASE = '/api';
export const isCloud = (import.meta as any).env?.PROD;

export const getCurrentUser = (): User | null => {
    const u = localStorage.getItem('user');
    return u ? JSON.parse(u) : null;
};

type FetchOptions = RequestInit & {
    skipAuth?: boolean;
};

export const apiClient = async (endpoint: string, options: FetchOptions = {}) => {
    const headers = new Headers(options.headers);
    
    if (!options.skipAuth) {
        const user = getCurrentUser();
        if (user && user.id) {
            headers.set('X-User-Id', user.id);
        }
    }

    if (!headers.has('Content-Type') && !(options.body instanceof FormData)) {
        headers.set('Content-Type', 'application/json');
    }

    const response = await fetch(`${API_BASE}${endpoint}`, {
        ...options,
        headers
    });

    if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || response.statusText);
    }

    const text = await response.text();
    return text ? JSON.parse(text) : null;
};
